import styled from 'styled-components';
import { colors, dimensions } from 'modules/common/styles';

const imageSize = 30;

const Members = styled.div`
  padding-top: ${dimensions.unitSpacing - 5}px;
`;

const MemberImg = styled.img`
  width: ${imageSize}px;
  height: ${imageSize}px;
  border-radius: ${imageSize / 2}px;
  background: ${colors.bgActive};
  border: 2px solid ${colors.colorWhite};
  margin-left: -8px;

  &:first-child {
    margin-left: 0;
  }
`;

const InsightRow = styled.div`
  position: relative;
  background: #fff;
  border-radius: 15px;
  margin: 3rem;
  float:left;
  width:60%;
`;

const ControlLabels = styled.div`
  margin-right: 10px;
  left: 10px;
  top: -10px;
  padding: 0px 8px 5px 8px;
  background: #ffffff;
  font-weight: 600;
  color: #393939;
  font-size: 14px;
`;

const DataWrapperClass = styled.div`
  section.sc-iELTvK.dgWnOn {
    background: #fff;
    margin-left: 20px;
    margin-right: 20px;
  }
  section.sc-jtRfpW.daxgFZ {
    margin-right: 20px;
  }
  section.sc-iELTvK.dstvIj {
    background: #fff;
    margin-left: 20px;
  }
`;

const More = MemberImg.withComponent('span').extend`
  color: ${colors.colorWhite};
  text-align: center;
  vertical-align: middle;
  font-size: ${dimensions.unitSpacing}px;
  background: ${colors.colorCoreLightGray};
  display: inline-block;
  line-height: ${dimensions.coreSpacing + 6}px;
  cursor: pointer;
`;

const CustomTabs = styled.div`
  // text-align: -webkit-center;
  width: 100%;

  .customTabs {
    border: none;
    border-radius: 6px;
    // background: #EEEEEE;
    margin: 0;
    // width: fit-content;
  }
  .nav-tabs {
    border: none;
    // display: flex;
    // justify-content: space-evenly;
    // border: 1.88938px solid #EDE7F6;
    // border-radius: 6px;
    // background: #EEEEEE;
    display: block;
    // justify-content: center;
    margin-bottom: 18px;
  }

  .nav-tabs > li > a {
    margin: none;
    padding: 5px 25px;
    margin-right: 0px;
    font-weight: 500;
    font-size: 14px;
    border: none;
    color: #a6a6a6;
    background: #eeeeee;
    border-radius: none !important;
    line-height: normal !important;
  }

  .nav-tabs > li > a:hover,
  .nav-tabs > li > a:focus {
    border-color: none;
    outline: none;
  }

  .nav-tabs > li:first-child > a {
    border-radius: 6px 0px 0px 6px !important;
  }

  .nav-tabs > li > a {
    border-radius: 0px 0px 0px 0px !important;
  }

  .nav-tabs > li:last-child > a {
    border-radius: 0px 6px 6px 0px !important;
  }

  .nav-tabs > li:first-child.active > a,
  .nav-tabs > li:first-child.active > a:focus,
  .nav-tabs > li:first-child.active > a:hover {
    border-radius: 6px 0px 0px 6px;
  }

  .nav-tabs > li:last-child.active > a,
  .nav-tabs > li:last-child.active > a:focus,
  .nav-tabs > li:last-child.active > a:hover {
    border-radius: 0px 6px 6px 0px;
  }

  .nav-tabs > li.active > a,
  .nav-tabs > li.active > a:focus,
  .nav-tabs > li.active > a:hover {
    background: #0161ed;
    box-shadow: 0px 7.125px 14.25px rgba(2, 51, 114, 0.2);
    border: none;
    margin: 0;
    border-radius: 0px 0px 0px 0px;
    color: #fff;
  }
`;

const Info = styled.div``;

export {
  MemberImg,
  Members,
  More,
  DataWrapperClass,
  InsightRow,
  ControlLabels,
  CustomTabs,
  Info,
};



// WEBPACK FOOTER //
// src/modules/screens/settings/Integrations/styles.js